// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__ZGPd3","info":"Panel_info__HmfW8","note":"Panel_note__4Y7ql","close":"Panel_close__T258M","btns":"Panel_btns__QjC8V","button":"Panel_button__TY-G1"};